import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const navItems = [
    { path: '/config', label: 'Config', icon: '⚙️' },
    { path: '/tracking', label: 'Track', icon: '📝' },
    { path: '/progress', label: 'Progress', icon: '📊' }
  ];

  const handleLogout = async () => {
    await logout();
  };

  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-content">
          <h1 className="nav-title">💪 Sweat Or Regret</h1>
          <div className="nav-links">
            {navItems.map(item => (
              <button
                key={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => navigate(item.path)}
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
            <button
              className="nav-link"
              onClick={handleLogout}
              title={user?.email}
            >
              <span>🚪</span>
              <span>Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
